module.exports = __webpack_public_path__ + "img/fanyu.bed68a0b.png";